const postFrequencyStr = {
  toastr: 'Added frequency',
  toastr1: 'has been successfully added',
  toastrError: 'Attendance already registered',
  toastrError1: 'Enter another name'
};

export default postFrequencyStr;
